// src/app/components/training/TrainingRoomViewer.tsx
import React from "react";
import { Box, Center, Loader, Text } from "@mantine/core";
import { useAppSelector } from "../app/hooks";
import type { IRootState } from "../app/store";
import { useGetTdroomSingleQuery } from "../../openapi";

import PixBimViewer from "../components/PixBimViewer/PixBimViewer"; // juster path
import { selectTdroomPixPolygons } from "./trainingdataSelectors";

export const TrainingRoomViewer: React.FC = () => {
  const activeTdRoomId = useAppSelector((s: IRootState) => s.training.activeTdRoomId);

  // trigger fetch (cache fylles), selve polygonene hentes fra selector
  const { isLoading, isError } = useGetTdroomSingleQuery(
    activeTdRoomId ? { tdroomId: activeTdRoomId } : (undefined as any),
    { skip: !activeTdRoomId }
  );

  const polygons = useAppSelector(selectTdroomPixPolygons);

  if (!activeTdRoomId) {
    return (
      <Center h="100%">
        <Text c="dimmed">Velg et rom i tabellen.</Text>
      </Center>
    );
  }

  if (isLoading) {
    return (
      <Center h="100%">
        <Loader />
      </Center>
    );
  }

  if (isError) {
    return (
      <Center h="100%">
        <Text c="dimmed">Klarte ikke å hente rommet.</Text>
      </Center>
    );
  }

  if (!polygons || polygons.length === 0) {
    return (
      <Center h="100%">
        <Text c="dimmed">Ingen geometri å vise.</Text>
      </Center>
    );
  }

  return (
    <Box h="100%" w="100%">
      <PixBimViewer angle={0} paths={[]} polygons={polygons} />
    </Box>
  );
};
